export default "__VITE_ASSET__DBzns1l6__"